import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/core/styles";
import {TextField} from "@material-ui/core";
import {KeyboardDateTimePicker} from "@material-ui/pickers";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import GridBlock from "components/GridBlock";
import IconButton from "components/button/IconButton";
import WorkableIconButton from "components/button/WorkableIconButton";
import DateFormats from "constants/DateFormats";

const useStyle = makeStyles(theme => ({
    root: {

        '&>*:not(:first-child):not(:last-child)': {
            marginLeft: theme.spacing(4),
        }
    },
    search: {
        width: 182,
    }
}));

const EMPTY_SEARCH_OBJECT = {subject: '', message: '', recipients: '', dateFrom: null, dateTo: null}
const MAX_SEARCH_LENGTH = 100;

function EmailListSearch(
    {
        searchInProgress,
        doSearch
    }) {


    const getInitValue = () => {

        return {...EMPTY_SEARCH_OBJECT};
    }

    const classes = useStyle();
    const [value, setValue] = useState(getInitValue());
    const [submitState, setSubmitState] = useState(0);

    useEffect(() => {
        if (submitState && !searchInProgress) {
            const valueFiltered = Object.keys(value)
                .filter((k) => value[k])
                .reduce((a, k) => ({...a, [k]: value[k]}), {});
            doSearch(valueFiltered);
        }
        // eslint-disable-next-line
    }, [submitState]);

    const handleChange = (id, e) => {
        setValue({...value, [id]: e.target.value});
    }

    const handleSubmit = () => {
        setSubmitState(x => x + 1)
    };


    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit()
        }
    }

    const handleChangeDate = (id, date) => {
        const dateValue = date ? date: null;
        setValue({...value, [id]: dateValue})
    };

    return (
        <>
            {/*<BoldTypography>{Tr('search_box')}</BoldTypography>*/}
            <GridBlock className={classes.root}>

                <TextField
                    className={classes.search}
                    label={Tr('search_subject')}
                    onChange={e => handleChange('subject', e)}
                    onKeyUp={handleKeyPress}
                    fullWidth
                    value={value.subject}
                    inputProps={{maxLength: MAX_SEARCH_LENGTH}}
                />

                <TextField
                    className={classes.search}
                    label={Tr('search_content')}
                    onChange={e => handleChange('message', e)}
                    onKeyUp={handleKeyPress}
                    fullWidth
                    value={value.message}
                    inputProps={{maxLength: MAX_SEARCH_LENGTH}}
                />

                <TextField
                    className={classes.search}
                    label={Tr('recipients_content')}
                    onChange={e => handleChange('recipients', e)}
                    onKeyUp={handleKeyPress}
                    fullWidth
                    value={value.recipients}
                    inputProps={{maxLength: MAX_SEARCH_LENGTH}}
                />
                <KeyboardDateTimePicker
                    className={classes.search}
                    label={Tr('date_from')}
                    ampm={false}
                    format={DateFormats.DATETIME_FORMAT}
                    variant='dialog'
                    cancelLabel={Tr('cancel')}
                    value={value.dateFrom}
                    invalidDateMessage={Tr("invalid_date_format")}
                    onChange={e => handleChangeDate('dateFrom', e)}
                />
                <KeyboardDateTimePicker
                    className={classes.search}
                    label={Tr('date_to')}
                    ampm={false}
                    format={DateFormats.DATETIME_FORMAT}
                    variant='dialog'
                    cancelLabel={Tr('cancel')}
                    value={value.dateTo}
                    invalidDateMessage={Tr("invalid_date_format")}
                    onChange={e => handleChangeDate('dateTo', e)}
                />

                <div>
                    <WorkableIconButton Icon={SearchIcon} working={searchInProgress} onClick={handleSubmit} tooltip={Tr('search')}/>
                    <IconButton disabled={searchInProgress} Icon={ClearIcon} tooltip={Tr('clear')} onClick={() => {
                        setValue(EMPTY_SEARCH_OBJECT);
                        handleSubmit()
                    }}/>
                </div>
            </GridBlock>
        </>
    )
}

EmailListSearch.propTypes = {
    classes: PropTypes.any,
}


export default EmailListSearch;